<template>
  <div id="files">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateGroupForm = null;
                modalGroupVisible = true;
              "
            >
              {{ $t("participantManagament.segmentations.addGroup") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="filter-card card card-collapsed">
            <div class="card-header header-elements-inline">
              <h5 class="card-title">{{ this.$t("event.components.participants.navbar.filterRecord") }}</h5>

              <div class="header-elements">
                <div class="list-icons">
                  <el-button-group>
                    <el-button size="mini" @click="$store.state.tags.filter.searchTerm = ''" round>{{ $t("event.buttons.reset") }}</el-button>
                    <el-button size="mini" type="danger" @click="isFilterEnabled = false" round>{{ $t("event.buttons.close") }}</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-8">
                  <el-input clearable v-model="$store.state.tags.filter.searchTerm" :placeholder="$t('event.textbox.filterLabel')"></el-input>
                </div>
                <div class="form-group col-md-4">
                  <el-select v-model="$store.state.tags.filter.groupID" :placeholder="$t('event.filter.group')">
                    <el-option v-for="item in $store.state.groups.items" :key="item.id" :label="item.title" :value="item.id" clearable></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.registrationtags.title") }}</h5>
              <span v-if="$store.state.groups.items.length > 0">
                <template v-if="$i18n.locale == 'tr'">
                  Toplam
                  <b>{{ $store.state.groups.items.length }}</b>
                  grup ve
                  <b>{{ getTagsCount }}</b>
                  adet etiket bulunmaktadır.
                </template>
                <template v-else>
                  There are
                  <b>{{ $store.state.groups.items.length }}</b>
                  groups in a total of
                  <b>{{ getTagsCount }}</b>
                  tags.
                </template>
              </span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/attendee-segmentation--how-to-use-segmentation')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refresh" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="$store.state.groups.items.length > 0">
            <div class="groups-wrapper" :date="currDate">
              <draggable :list="$store.state.groups.items" class="groups-item list-group-o" group="b" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @start="drag = true" @end="saveSorting">
                <div class="groups-container" v-for="(item, index) in $store.state.groups.items" :key="item.id + index">
                  <div class="groups-header" :class="item.isActive || item.showOnApp ? '' : 'passive'">
                    <span>
                      <i :style="'color:' + item.color" :class="loading == 'deleteGroup-' + item.id ? 'el-icon-loading' : 'fas fa-square'"></i>
                      {{ item.title }}
                    </span>

                    <div class="group-controls">
                      <span
                        @click="
                          updateGroupForm = item.id;
                          modalGroupVisible = true;
                        "
                      >
                        <i class="fa fa-pen"></i>
                      </span>
                      <span>
                        <i :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                      </span>
                    </div>
                  </div>

                  <draggable :list="item.tags" class="groups-inner-items list-group-o" group="a" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @start="drag = true" @end="saveSorting">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                      <div class="groups-inner-item" v-for="element in item.tags" :key="element.id" :class="element.isActive ? '' : 'passive'">
                        <i class="grab" :class="loading == item.id || loading == 'deleteFile-' + element.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                        <div class="group-item-inner-title">
                          <i class="fas fa-circle" :style="'color:' + element.color"></i>
                          <div class="text-container">
                            <span>{{ element.title }}</span>
                            <i class="fas fa-print" v-if="!element.print"></i>
                          </div>
                        </div>
                        <div class="group-item-inner-actions d-flex flex-shrink-0" style="gap:10px; align-items:center;">
                          <div class="group-item-inner-usage">
                            <template v-if="element.stock == 0">
                              <span>{{ element.usage }} /</span>
                              <i class="fas fa-infinity" style="color:#268ea6;"></i>
                            </template>
                            <template v-else>
                              <span class="w-100">
                                {{ element.usage + " / " + element.stock }}
                              </span>
                            </template>
                          </div>
                          <el-popover placement="top-start" width="200" trigger="click">
                            <template>
                              <div
                                class="action-item"
                                @click="
                                  updateForm = element.id;
                                  editGroupID = null;
                                  modalVisible = true;
                                "
                              >
                                <span>{{ $t("participantManagament.segmentations.editTag") }}</span>
                                <i class="fas fa-pen"></i>
                              </div>
                              <el-popconfirm @confirm="deleteItem(element.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                <div class="action-item" slot="reference">
                                  <span>{{ $t("participantManagament.segmentations.deleteTag") }}</span>
                                  <i :class="loading == 'deleteTag-' + element.id ? 'el-icon-loading' : 'fas fa-trash'"></i>
                                </div>
                              </el-popconfirm>
                            </template>
                            <i aria-hidden="true" slot="reference" class="action-icon fa fa-ellipsis-v"></i>
                          </el-popover>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>

                  <div class="groups-footer">
                    <el-button
                      round
                      size="small"
                      type="primary"
                      @click="
                        updateForm = null;
                        editGroupID = item.id;
                        modalVisible = true;
                      "
                    >
                      <i class="fas fa-plus"></i>
                      {{ $t("participantManagament.segmentations.addTag") }}
                    </el-button>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-segmentation-lottie'"
              :title="$t('event.menu.registrationtags.title')"
              @btnAdd="
                updateGroupForm = null;
                modalGroupVisible = true;
              "
              @btnRefresh="refresh()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="$t('event.tags.editLabel')" class="medium" center modal-append-to-body destroy-on-close>
      <TagAddUpdate @closeDialog="modalVisible = false" :id="updateForm" v-if="modalVisible" @deleteMe="deleteItem" :groupId="editGroupID" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalGroupVisible" :title="updateGroupForm ? $t('event.tags.editGroup') : $t('event.tags.addGroup')" class="medium" center modal-append-to-body destroy-on-close>
      <GroupAddUpdate @closeDialog="modalGroupVisible = false" @deleteMe="deletGroups" v-if="modalGroupVisible" :id="updateGroupForm" />
    </el-dialog>
  </div>
</template>
<script>
import TagAddUpdate from "../../components/TagAddUpdate";
import GroupAddUpdate from "../../components/GroupAddUpdate.vue";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import draggable from "vuedraggable";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.segmentation")
    };
  },
  components: { TagAddUpdate, PageCountInfo, draggable, GroupAddUpdate },
  name: "Tags",
  data() {
    return {
      editGroupID: null,
      modalVisible: false,
      updateForm: null,
      modalGroupVisible: false,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      updateFormCategory: null,
      drag: false,
      loading: false,
      updateGroupForm: null,
      currDate: new Date().getTime(),
      helpUrl: this.$helpUrl + "tags"
    };
  },
  methods: {
    filterParticipantsByTag(id) {
      this.$store.state.participants.filter = {
        searchTerm: null,
        skip: 0,
        take: 20,
        total: 0,
        page: 1,
        checkIn: null,
        isCardPrinted: null,
        voucherSendStatus: null,
        voucherTaskStatus: null,
        voucherType: null,
        activationStatus: null,
        minimumCheckInDate: null,
        groupIDs: null,
        activationCode: null,
        paymentType: null,
        maximumCheckInDate: null,
        paymentStatus: null,
        promotionIDs: null,
        tagIDs: null,
        subEventIDs: null,
        couponCode: null,
        paymentID: null,
        minCardPrintDate: null,
        maxCardPrintDate: null,
        minCheckInDate: null,
        maxCheckInDate: null,
        checkInDateRange: null,
        cardDateRange: null
      };
      this.$store.state.participants.filter.tagIDs = [id];
      this.$router.push({ name: "participants" });
    },
    itemUpdated(item) {
      this.$store.dispatch("getGroups");
    },
    itemAdded(item) {
      this.$store.dispatch("getGroups");
    },
    handleSizeChange(take) {
      this.$store.commit("setTagTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setTagPage", page);
    },
    async deletGroups(id) {
      this.loading = "deleteGroup-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteGroup", id);
        this.loading = false;
      }, 500);
    },
    refresh() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getGroups");
        this.loading = false;
      }, 500);
    },
    async deleteItem(id) {
      this.loading = "deleteTag-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteTag", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getGroups");
        }
        this.loading = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleTag", { index, value });
    },

    async saveSorting() {
      var res = await axios.post("/Segmentation/UpdateSorting", { items: this.$store.state.groups.items });
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
      } else {
        this.$message.success(res.data.alert.message);
      }
      await this.$store.dispatch("getGroups");
    }
  },

  // mounted() {
  //   this.$store.dispatch('getTags');
  // },
  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getGroups");
      this.loading = false;
    }, 500);
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getTagsCount() {
      var i = 0;
      this.$store.state.groups.items.map(k => {
        i = i + k.tags.length;
      });
      return i;
    }
  },
  watch: {
    "$store.state.tags.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getTags");
      }, 500);
    },
    "$store.state.tags.filter.groupID": function() {
      clearTimeout(this.timeout);
      this.$store.dispatch("getTags");
    }
  }
};
</script>

<style lang="less">
.list-group-o {
  & > span {
    min-height: 260px;
  }
}
.groups-wrapper {
  padding: 16px 0px;

  .groups-item {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    min-height: 350px;
    grid-gap: 10px;

    .groups-container {
      background-color: #fbfbfb;
      border: 0.5px solid #f1f3f6;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-radius: 8px;
      position: relative;

      .groups-header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: #f1f1f1;
        padding: 10px 14px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        &.passive {
          background-color: #fff2f2;
        }

        span {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 220px;

          i {
            font-size: 20px;
          }

          &:first-child {
            i {
              margin-right: 6px;
            }
          }

          &:last-child {
            i {
              font-size: 16px;
              cursor: pointer;
            }
          }
        }

        .group-controls {
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 32px;
            height: 32px;
            margin-left: 4px;

            &:last-child {
              i {
                cursor: grab;
              }
            }

            i {
              box-sizing: border-box;
              font-size: 20px;
              color: #505763;
              padding: 2px 0px;
              cursor: pointer;
            }
          }

          &.passive {
            background-color: #fff2f2;
          }
        }
      }

      .groups-inner-items {
        width: 100%;
        min-height: 260px;
        // max-height: 280px;
        // overflow-y:auto;
        padding: 0px 8px;
        position: relative;
        height: 100%;

        & > span {
          min-height: 260px;
          height: 100%;
          display: block;
        }

        .groups-inner-item {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          background: #f1f1f1;
          padding: 8px 10px;
          margin: 8px 0px;
          border-radius: 8px;

          &:last-child {
            margin-bottom: 0px;
          }

          &.passive {
            background-color: #fff2f2;
          }

          .grab {
            box-sizing: border-box;
            font-size: 20px;
            color: #505763;
            margin-right: 8px;
            cursor: grab;
          }

          .group-item-inner-title {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-content: center;
            width: 100%;

            i {
              box-sizing: border-box;
              font-size: 20px;
              color: #505763;
              margin-right: 4px;
            }

            .text-container {
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                font-size: 13px;
                color: #505763;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 160px;
                display: block;

                b {
                  font-size: 13px;
                  color: #292f3b;
                  font-weight: 600;
                }
              }
              & > i {
                margin-left: 4px;
                font-size: 17px;
                color: #ff6565;
              }
            }
          }

          .group-item-inner-actions {
            background: transparent;
            .action-icon {
              background: transparent;
              display: flex;
              align-items: center;
              margin-left: 12px;
              margin-right: 0px;
              color: #8c929c;
              font-size: 12px;
              padding: 6px 0px;
              cursor: pointer;
            }
          }
        }
      }

      .groups-footer {
        padding: 6px 0px 6px;
      }
    }
  }
}

.action-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 6px 4px;
  cursor: pointer;

  span {
    font-size: 13px;
    color: #505763;
    font-weight: 500;
  }
  i {
    color: #292f3b;
  }

  &:last-child {
    span,
    i {
      color: #ff6565;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Tags.vue